export default "__VITE_ASSET__DUAj6zCY__"